import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "dueDate", "hovered", "id", "inline", "isDayLabel", "isToday", "keyboardFocused", "label", "onClick", "pressed", "rangeEnd", "rangeSelected", "rangeStart", "selected", "withinRange"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import Text from '@bubble-ui/primitive-text';
import Touchable from '@bubble-ui/primitive-touchable';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var DatePickerDayComponent = function DatePickerDayComponent(_ref) {
  var passedDisabledProp = _ref.disabled,
    dueDate = _ref.dueDate,
    passedHoveredProp = _ref.hovered,
    id = _ref.id,
    inline = _ref.inline,
    isDayLabel = _ref.isDayLabel,
    isToday = _ref.isToday,
    passedKeyboardFocusedProp = _ref.keyboardFocused,
    label = _ref.label,
    onClick = _ref.onClick,
    passedPressedProp = _ref.pressed,
    rangeEnd = _ref.rangeEnd,
    rangeSelected = _ref.rangeSelected,
    rangeStart = _ref.rangeStart,
    selected = _ref.selected,
    withinRange = _ref.withinRange,
    props = _objectWithoutProperties(_ref, _excluded);
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var _useInteractiveStateC = useInteractiveStateCombined(_objectSpread(_objectSpread({}, props), {}, {
      disabled: passedDisabledProp,
      hovered: passedHoveredProp,
      keyboardFocused: passedKeyboardFocusedProp,
      pressed: passedPressedProp
    })),
    _useInteractiveStateC2 = _slicedToArray(_useInteractiveStateC, 2),
    _useInteractiveStateC3 = _useInteractiveStateC2[0],
    hovered = _useInteractiveStateC3.hovered,
    disabled = _useInteractiveStateC3.disabled,
    keyboardFocused = _useInteractiveStateC3.keyboardFocused,
    pressed = _useInteractiveStateC3.pressed,
    eventHandlers = _useInteractiveStateC2[1];
  var _getDefaultStyleSheet = getDefaultStyleSheet({
      designContext: designContext,
      disabled: disabled,
      dueDate: dueDate,
      hovered: hovered,
      inline: inline,
      isDayLabel: isDayLabel,
      keyboardFocused: keyboardFocused,
      label: label,
      pressed: pressed,
      rangeEnd: rangeEnd,
      rangeSelected: rangeSelected,
      rangeStart: rangeStart,
      selected: selected,
      withinRange: withinRange
    }),
    buttonStyle = _getDefaultStyleSheet.buttonStyle,
    colorizerStyle = _getDefaultStyleSheet.colorizerStyle,
    focusStyle = _getDefaultStyleSheet.focusStyle,
    focusWrapperStyle = _getDefaultStyleSheet.focusWrapperStyle,
    todayStyle = _getDefaultStyleSheet.todayStyle,
    todayWrapperStyle = _getDefaultStyleSheet.todayWrapperStyle,
    dueDateIndicatorStyle = _getDefaultStyleSheet.dueDateIndicatorStyle,
    dueDateIndicatorWrapperStyle = _getDefaultStyleSheet.dueDateIndicatorWrapperStyle,
    leftSideBackgroundStyle = _getDefaultStyleSheet.leftSideBackgroundStyle,
    rightSideBackgroundStyle = _getDefaultStyleSheet.rightSideBackgroundStyle,
    wrapperStyle = _getDefaultStyleSheet.wrapperStyle,
    paragraphSecondaryCorrectFootprintMediumCenteredStyle = _getDefaultStyleSheet.paragraphSecondaryCorrectFootprintMediumCenteredStyle,
    paragraphTertiaryCorrectFootprintCenteredMetadataStyle = _getDefaultStyleSheet.paragraphTertiaryCorrectFootprintCenteredMetadataStyle;
  return /*#__PURE__*/React.createElement(Touchable, _extends({
    disabled: disabled || isDayLabel || label == null || label === '',
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    onPress: onClick,
    style: buttonStyle
  }, props, eventHandlers), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.wrapper,
    style: wrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.leftSideBackground,
    style: leftSideBackgroundStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.rightSideBackground,
    style: rightSideBackgroundStyle
  }), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.colorizer,
    style: colorizerStyle
  }, /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 0,
    tag: "paragraph",
    style: isDayLabel ? paragraphTertiaryCorrectFootprintCenteredMetadataStyle : paragraphSecondaryCorrectFootprintMediumCenteredStyle
  }, label)), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.focusWrapper,
    style: focusWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.focus,
    style: focusStyle
  })), isToday && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.todayWrapper,
    style: todayWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.today,
    style: todayStyle
  })), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.dueDateIndicatorWrapper,
    style: dueDateIndicatorWrapperStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.dueDateIndicator,
    style: dueDateIndicatorStyle
  }))));
};
DatePickerDayComponent.displayName = 'DatePickerDay';
export var DatePickerDay = withProvisionalOverrideFromContext(DatePickerDayComponent);
//# sourceMappingURL=index.js.map